import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img 
              src="/logo_efc.svg" 
              alt="EFC Buseck Logo" 
              className="logo-image"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <h1 className="logo-text">EFC Buseck</h1>
          </Link>

          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            {user ? (
              <>
                <Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link>
                <Link to="/spiele" onClick={() => setIsMenuOpen(false)}>Alle Spiele</Link>
                <Link to="/news" onClick={() => setIsMenuOpen(false)}>News</Link>
                <Link to="/shop" onClick={() => setIsMenuOpen(false)}>Klamotten</Link>
                <Link to="/ueber-uns" onClick={() => setIsMenuOpen(false)}>Über uns</Link>
                <Link to="/profil" onClick={() => setIsMenuOpen(false)}>Profil</Link>
                {isAdmin() && (
                  <Link to="/admin" onClick={() => setIsMenuOpen(false)}>Admin</Link>
                )}
                <button onClick={handleLogout} className="btn btn-secondary">
                  Abmelden
                </button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setIsMenuOpen(false)}>Anmelden</Link>
                <Link to="/registrieren" onClick={() => setIsMenuOpen(false)}>Registrieren</Link>
              </>
            )}
          </nav>

          <button className="menu-toggle" onClick={toggleMenu}>
            ☰
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
